import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';

// TODO: Replace with your Firebase project config
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'YOUR_API_KEY',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'dashboards.trendency.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'trend-fbase-prod-2',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'trend-fbase-prod-2.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || ''
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Auth providers
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

export async function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export async function signInWithMicrosoft() {
  return signInWithPopup(auth, microsoftProvider);
}

export async function sendEmailLink(email) {
  // Call our custom Cloud Function endpoint to send a branded sign-in email
  const apiBase = import.meta.env.VITE_API_BASE || 'https://us-central1-trend-fbase-prod-2.cloudfunctions.net/api';
  const response = await fetch(`${apiBase}/send-sign-in-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      callbackUrl: window.location.origin + '/auth/email-callback'
    })
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to send sign-in email');
  }
  // Save the email to complete sign-in after redirect
  window.localStorage.setItem('emailForSignIn', email);
}

export async function completeEmailSignIn() {
  if (isSignInWithEmailLink(auth, window.location.href)) {
    let email = window.localStorage.getItem('emailForSignIn');
    if (!email) {
      email = window.prompt('Please provide your email for confirmation');
    }
    const result = await signInWithEmailLink(auth, email, window.location.href);
    window.localStorage.removeItem('emailForSignIn');
    return result;
  }
  return null;
}

export default app;
